import {
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React from 'react';
import PhoneForm from './PhoneForm';

const PhoneFormModal = ({   showPhoneModal, setShowPhoneModal, phoneToUpdate}) => {
        return (
       <MDBModal backdrop={false}  tabIndex='-1' staticBackdrop={true} animationDirection='right'  open={showPhoneModal} >
            <MDBModalDialog  centered={true}>
            <MDBModalContent >
                <MDBModalBody >
                <PhoneForm showPhoneModal={showPhoneModal} setShowPhoneModal={setShowPhoneModal} phoneToUpdate={phoneToUpdate}/>
                </MDBModalBody>
                </MDBModalContent>
                
            </MDBModalDialog>
        </MDBModal>

    )
};
PhoneFormModal.propTypes = {
    showPhoneModal: PropTypes.bool.isRequired,
    setShowPhoneModal: PropTypes.func.isRequired,
    phoneToUpdate: PropTypes.object,
}
export default PhoneFormModal;
